import React from 'react';
import { Dashboard, Login, PrivateRoute, AuthWrapper, Error } from './pages';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

function App() {
  return (
    <AuthWrapper>
    <div>
      <Router>
        <Switch>
       <PrivateRoute  path='/' exact={true}>
      <Dashboard></Dashboard>
      </PrivateRoute> 
      <Route path='/login'>
      <Login />
      </Route>
      <Route path='*'>
       <Error/> 
        </Route>
        </Switch>
      </Router>
    </div>
    </AuthWrapper>
  );
}

export default App;
